const query = (id, isPreview) => `{
    secondaryNavigation(id: "${id}", preview: ${isPreview}) {
      navItem{
        dropdownItemsCollection{
          items {
            name
            url
            label
            title
            target
            gaEventClass
            gaEventLabel
          }
        }
      }  
    }
  } 
`
module.exports = { query }
